import React from 'react';
import ReactDOM from 'react-dom/client';  // Hier importieren wir die neue API
import './index.css';
import './styles.css'; // Menü-Stile (optional)

import App from './App';
import reportWebVitals from './reportWebVitals';

// Auth‑Context importieren
import { AuthProvider } from './hooks/useAuth';

// Globalen API-Service importieren
import api from './services/apiService';

// Den zentralen Axios-Client global verfügbar machen
window.axios = api;

const root = ReactDOM.createRoot(document.getElementById('root'));  // Erstellen des Root-Knotens mit der neuen API
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
